import { render, staticRenderFns } from "./VistaVisita.vue?vue&type=template&id=465d2b06"
import script from "./VistaVisita.vue?vue&type=script&lang=js"
export * from "./VistaVisita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports